import {
    NOTIFICATION_TYPE,
    PAGE_ROUTE,
    READER_PARAMS_TYPE,
} from '../enums';
import { ZOOM_LEVEL } from '../components/Editor/elements/enums';

/**
 * Maps notification kinds to the short label used in notification group
 * summaries so newly added system notifications stay in sync with the UI copy.
 */
export function getNotificationGroupItemTypeText(notificationType: NOTIFICATION_TYPE): string {
    switch (notificationType) {
    case NOTIFICATION_TYPE.annotationComment:
        return 'comment';
    case NOTIFICATION_TYPE.bookInviteClaimed:
        return 'book invite update';
    case NOTIFICATION_TYPE.webBookAccessRevokedChargeback:
    case NOTIFICATION_TYPE.webBookAccessRevokedRefund:
        return 'account update';
    default:
        return 'notification';
    }
}

/**
 * Centralizes notification deep-link generation so the reader route, zoom
 * query parameter, and refund/chargeback book route stay consistent.
 */
export function getNotificationLinkPath(data: {
    notification: {
        id: string,
        type: NOTIFICATION_TYPE,
        payload?: {
            annotationId?: string,
        },
    },
    supportEmailAddress: string,
}): string {
    const {
        notification,
        supportEmailAddress,
    } = data;

    switch (notification.type) {
    case NOTIFICATION_TYPE.annotationComment:
        if (notification.payload?.annotationId) {
            const params = new URLSearchParams([
                [READER_PARAMS_TYPE.zoom.toString(), ZOOM_LEVEL.five.toString()],
            ]);
            return `/${PAGE_ROUTE.book}/${notification.payload.annotationId}?${params.toString()}`;
        }
        throw Error(
            `Notification ${notification.id} did not have a link to annotation. `
            + `Please reach out to verascope support at: ${supportEmailAddress}.`,
        );
    case NOTIFICATION_TYPE.bookInviteClaimed:
        return '/';
    case NOTIFICATION_TYPE.webBookAccessRevokedChargeback:
    case NOTIFICATION_TYPE.webBookAccessRevokedRefund:
        return `/${PAGE_ROUTE.book}`;
    default:
        return '/';
    }
}
